import breakpoints, { breakpointKeys } from './breakpoints';
// if breakpoint is undifend it is samller than the
const getMediaQueryString = (breakpoint) => {
    let mediaQueryString = '';
    // no min for 'm' (our smalles defined breakpoint)
    const minQueryString = breakpoint === 's' ? undefined : `(min-width: ${breakpoints[breakpoint]}px)`;
    // the following two will be undefined for 'xxl' but we're not setting max for it anyway
    // '-1' since breakpoints are listed from largest to smallest
    const nextBreakpointIdx = breakpointKeys[breakpointKeys.indexOf(breakpoint) - 1];
    const nextBreakpointVal = breakpoints[nextBreakpointIdx];
    // no max for 'xxl'
    const maxQueriString = breakpoint === 'xxl' ? undefined : `(max-width: ${nextBreakpointVal}px)`;
    if (minQueryString && maxQueriString) {
        mediaQueryString = `${minQueryString} and ${maxQueriString}`;
    }
    else if (minQueryString) {
        mediaQueryString = minQueryString;
    }
    else if (maxQueriString) {
        mediaQueryString = maxQueriString;
    }
    return mediaQueryString;
};
export default getMediaQueryString;
//# sourceMappingURL=getMediaQueryString.js.map